module.exports = __webpack_public_path__ + "static/media/azhar.50aa7152.jpg";